import { actions } from 'react-table'
import { invoiceStatuses, purchaseStatuses } from '../data/threePlCreditAccountData'

const threePlCreditAccounts = {
  list: [],
  fullList: [],
  detail: null,
  activeList: 'credit',
  modalCustomer: false,
  editModalCustomer: false,
  detail: {
    runningBalance: 0,
    invoiceBalance: 0,
    billsBalance: 0,
  },
  filterStatuses: invoiceStatuses,
  filters: constructEmptyData(),
  isLoading: {
    list: true,
    fullList: true,
    modal: false,
    form: false,
  },
  csvDownloadableList: [],
}
const ThreePlCreditAccount = function (state = threePlCreditAccounts, action) {
  switch (action.type) {
    case 'TOGGLE_THREE_PL_CREDIT_ACCOUNT_LOADING': {
      return {
        ...state,
        isLoading: {
          ...state.isLoading,
          [action.key]: action.value,
        },
      }
    }

    case 'TOGGLE_THREE_PL_MODAL': {
      return {
        ...state,
        modalCustomer: action.value,
      }
    }
    case 'TOGGLE_THREE_PL_EDIT_MODAL': {
      return {
        ...state,
        editModalCustomer: action.value,
      }
    }
    case 'CHANGE_THREE_PL_DETAIL': {
      const newDetail = {
        ...state.detail,
        [action.key]: action.value,
      }

      return {
        ...state,
        detail: newDetail,
      }
    }

    case 'CHANGE_THREE_PL_EDIT_DETAIL': {
      const newDetail = {
        ...state.detail,
        [action.key]: action.value,
      }
      return {
        ...state,
        detail: newDetail,
      }
    }
    case 'TOGGLE_THREE_PL_CREDIT_ACCOUNT_LIST': {
      return {
        ...state,
        activeList: action.value,
      }
    }
    case 'TOGGLE_THREE_PL_STATUS_FILTER_LIST': {
      return {
        ...state,
        filterStatuses: action.value === 'credit' ? invoiceStatuses : purchaseStatuses,
      }
    }
    case 'UPDATE_THREE_PL_CREDIT_ACCOUNT_RUNNING_BALANCE': {
      return {
        ...state,
        detail: {
          ...state.detail,
          runningBalance: parseFloat(action.value).toFixed(2),
        },
      }
    }

    case 'UPDATE_THREE_PL_CREDIT_ACCOUNT_INVOICE_BALANCE': {
      return {
        ...state,
        detail: {
          ...state.detail,
          invoiceBalance: parseFloat(action.value).toFixed(2),
        },
      }
    }

    case 'UPDATE_THREE_PL_CREDIT_ACCOUNT_BILLS_BALANCE': {
      return {
        ...state,
        detail: {
          ...state.detail,
          billsBalance: parseFloat(action.value).toFixed(2),
        },
      }
    }

    case 'UPDATE_THREE_PL_CREDIT_ACCOUNT_FULL_LIST': {
      return {
        ...state,
        fullList: action.value,
      }
    }
    case 'UPDATE_THREE_PL_CREDIT_ACCOUNT_LIST': {
      return {
        ...state,
        list: action.value,
      }
      //   let newList = {}
      //   Object.entries(action.list).forEach(([key, value]) => (newList[key] = { ...state.fullList[key], ...value }))
      //   return {
      //     ...state,
      //     fullList: {
      //       ...state.fullList,
      //       ...newList,
      //     },
      //   }
    }
    case 'EMPTY_THREE_PL_EDIT_DETAIL': {
      return {
        ...state,
        detail: {},
      }
    }

    case 'UPDATE_SEARCH_FILTER': {
      return {
        ...state,
        filters: {
          ...state.filters,
          [action.key]: action.value,
        },
      }
    }
    case 'EMPTY_THREEPL_CREDIT_ACCOUNT_SEARCH_FILTER': {
      return {
        ...state,
        filters: constructEmptyData(),
      }
    }

    case 'SET_THREE_PL_CREDIT_ACCOUNT_CSV_LIST': {
      return {
        ...state,
        csvDownloadableList: action.value,
      }
    }

    default: {
      return state
    }
  }
}

export default ThreePlCreditAccount

function constructEmptyData() {
  return {
    search: '',
    status: '0',
    fromDate: '',
    toDate: '',
    openbalanceonly: 1,
  }
}
